<template>
  <div class="register-h5">
    <div class="register-h5-banner">
      <div class="register-h5-title">注册账号</div>
      <div class="register-h5-sub">没有账号请邮箱注册</div>
    </div>

    <div class="register-h5-form">
      <el-form :rules="ruleList" :model="user" ref="userForm">
        <el-form-item prop="name">
          <el-input placeholder="请输入您的邮箱" size="medium" class="inputOneClass" prefix-icon="el-icon-message"
                    v-model="user.name" autocomplete="new-password"></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <div style="display: flex; gap: 10px;">
            <el-input placeholder="邮箱收到的验证码" size="medium" class="inputOneClass" prefix-icon="el-icon-lock"
                      v-model="user.code"></el-input>
            <el-button type="primary" size="medium" style="flex-shrink: 0; margin-left: 0;" @click="getEmailCode">获取验证码</el-button>
          </div>
        </el-form-item>
        <el-form-item prop="password">
          <el-input placeholder="请设置密码" size="medium" class="inputOneClass" prefix-icon="el-icon-lock"
                    v-model="user.password" show-password autocomplete="new-password"></el-input>
        </el-form-item>
      </el-form>

      <el-button type="primary" size="medium" class="register-h5-btn" @click="registerClick">注册用户</el-button>

      <div class="register-h5-links">
        <span @click="$router.push('/login_h5')">已有账号？返回登录</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RegisterH5",
  data() {
    return {
      user: {},
      ruleList: {
        name: [
          {required: true, message: '请输入您的邮箱账号', trigger: 'blur'},
          {min: 3, max: 60, message: '长度在3-60个字符', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请设置密码', trigger: 'blur'},
          {min: 3, max: 60, message: '长度在3-60个字符', trigger: 'blur'}
        ],
        code: [
          {required: true, message: '请输入收到的验证码', trigger: 'blur'},
          {min: 3, max: 20, message: '长度在3-20个字符', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    getEmailCode() {
      if (!this.user.name) {
        this.$message.warning("请输入邮箱账号")
        return
      }
      if (!/^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/.test(this.user.name)) {
        this.$message.warning("请输入正确的邮箱账号")
        return
      }
      this.$http.post("/big/email_code", this.user).then(res => {
        if (res.data.code === "200") {
          this.$message.success("邮箱验证码发送成功，请到对应邮箱查看")
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    registerClick() {
      this.$refs["userForm"].validate(valid => {
        if (valid) {
          this.$http.post("/big/register", this.user).then(res => {
            if (res.data.code === "200") {
              this.$router.push("/login_h5")
              this.$message.success("注册成功，请登录！")
            } else {
              this.$message.error(res.data.message)
            }
          });
        }
      })
    }
  }
}
</script>

<style scoped>
.register-h5 {
  min-height: 100vh;
  background: linear-gradient(160deg, #409eff 0%, #2b6fd4 45%, #f5f7fa 45%, #f5f7fa 100%);
  padding: 0 20px;
  box-sizing: border-box;
}
.register-h5-banner {
  padding: 70px 10px 50px;
  color: #fff;
}
.register-h5-title {
  font-size: 24px;
  font-weight: 700;
}
.register-h5-sub {
  margin-top: 10px;
  font-size: 14px;
  opacity: 0.85;
}
.register-h5-form {
  background: #fff;
  border-radius: 12px;
  padding: 24px 20px 30px;
  box-shadow: 0 6px 24px rgba(31, 45, 61, 0.12);
}
.register-h5-btn {
  width: 100%;
  margin-top: 6px;
  letter-spacing: 4px;
}
.register-h5-links {
  margin-top: 18px;
  font-size: 14px;
  color: #409eff;
  text-align: center;
}
.register-h5-links span {
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
</style>
